import { TutorialConfig } from "../types/tutorial";
import dashboard from "./dashboard.tutorial";
import tariffs from "./tariffs.tutorial";
import predictive from "./predictive.tutorial";
import routeOptimization from "./routeOptimization.tutorial";
import orders from "./orders.tutorial";

export const tutorialConfigs: Record<string, TutorialConfig> = {
  "/dashboard": dashboard,
  "/tariffs": tariffs,
  "/predictive": predictive,
  "/route-optimization": routeOptimization,
  "/orders": orders,
};

export const getTutorialConfig = (pathname: string): TutorialConfig | null => {
  return tutorialConfigs[pathname] ?? null;
};

export { dashboard, tariffs, predictive, routeOptimization, orders };
